/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrUserEntity } from '../../models/dbr-user-entity';

export interface UsersControllerFindAllByEventId$Params {
  eventId: number;
}

export function usersControllerFindAllByEventId(http: HttpClient, rootUrl: string, params: UsersControllerFindAllByEventId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrUserEntity>>> {
  const rb = new RequestBuilder(rootUrl, usersControllerFindAllByEventId.PATH, 'get');
  if (params) {
    rb.path('eventId', params.eventId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DbrUserEntity>>;
    })
  );
}

usersControllerFindAllByEventId.PATH = '/users/by-event-id/{eventId}';
